package com.swetdot.swetgram.domain

import com.swetdot.swetgram.protocol.dto.XpShopCategory

enum class XpShopCategoryDomain {
    STREAK_SAVER,
    APP_ICON,
    AVATAR_FRAME,
    BADGE,
    BLACK_PASS,
    REACTION_PACK,
    OTHER;

    companion object {
        fun fromWire(category: XpShopCategory): XpShopCategoryDomain = when (category) {
            XpShopCategory.STREAK_SAVER -> STREAK_SAVER
            XpShopCategory.APP_ICON -> APP_ICON
            XpShopCategory.AVATAR_FRAME -> AVATAR_FRAME
            XpShopCategory.BADGE -> BADGE
            XpShopCategory.BLACK_PASS -> BLACK_PASS
            XpShopCategory.REACTION_PACK -> REACTION_PACK
            XpShopCategory.UNKNOWN -> OTHER
        }
    }
}

data class XpShopCatalogDomain(
    val items: List<XpShopItemDomain>,
    val spendableXp: Int,
    val streakFreezes: Int,
)

data class XpShopItemDomain(
    val code: String,
    val category: XpShopCategoryDomain,
    val title: String,
    val description: String,
    val priceXp: Int,
    val badgeIcon: String?,
    val enabled: Boolean,
    val isOwned: Boolean = false,
)

data class XpShopPurchaseDomain(
    val purchaseId: String,
    val itemCode: String,
    val remainingXp: Int,
    val streakFreezes: Int,
)
